import {AuwTwoClickVideo} from "./AuwTwoClickVideo";

if($('.two-click-video-poster').length) {
    $.each($('.two-click-video-poster'),function(i,e) {
        new AuwTwoClickVideo($(e));
    });
}

